import * as ActionTypes from '@/stores/sale/actions';
import uuid from 'uuid/v4';
import _ from 'lodash';
import message from '@/utils/message';
import perms from '@/common/permissions/sale/perms';

/**
 * 呼叫中心服务
 */
class TcccCallCenter {
  /**
   * 构造函数
   * @param webApi WebApi
   * @param messageBox 消息对话框
   * @param vendor 呼叫中心供应商，如青牛的 `channelsoft/ChannelSoftCC`
   */
  constructor(webApi, vendor) {
    this.webApi = webApi;
    this.vendor = vendor;
  }

  /**
   * 初始化呼叫中心，同时绑定用户登录态
   * @param loginStatus 当前用户登录态
   */
  init(loginStatus) {
    this.loginStatus = loginStatus;
    this.vendor.bind(loginStatus);
    this.vendor.onDialOut(this._handleDialOut);
    this.vendor.onDialStatusUpdate(this._handleDialStatusUpdate);
  }

  /**
   * @description 已有号码，呼叫指定的电话号码
   * @param leadId
   * @param contactId
   * @param number
   * @return {Promise<any>}
   */
  dialOut({ leadId, contactId, number, leadDetail }) {
    if(this.vendor.getLimitQuickClickCall()) {
      message.warn('电话已拨打中，请勿重复拨打...');
      return;
    }
    this.vendor.setLimitQuickClickCall(true);
    return this.vendor.dialOut(number, { leadId, contactId, leadDetail });
  }

  setLimitQuickClickCall(flag) {
    this.vendor.setLimitQuickClickCall(flag);
  }
  /**
   * @description 手动输入号码拨打
   */
  makeCall(number, extraParams, extraResp, params) {
    if(this.vendor.getLimitQuickClickCall()) {
      message.warn('电话已拨打中，请勿重复拨打...');
      return;
    }
    this.vendor.setLimitQuickClickCall(true);
    return this.vendor.makeCall(number, extraParams, extraResp, params);
  }

  checkDialOut(leadId, params) {
    return this.webApi
      .dialOut()
      .dispatchJson(ActionTypes.DIAL_OUT, {
        data: leadId ? _.assign({}, params, { leadId }) : params,
      })
      .then((r2) => {
        console.log('第六步调用dial-out接口拿到拨打的手机号', r2);
        return r2;
      });
  };

  /**
   * 当呼出时，触发回调
   * @param callback
   */
  onDialOut(callback) {
    this.dialOutCallback = callback;
  }

  /**
   * 当状态发生改变时，触发回调，告诉外层是否可以呼出电话
   * @param callback
   */
  onUpdateStatus(callback) {
    // 登录成功 && 登出成功
    return this.vendor.onUpdateStatus(callback);
  }

  handleCallBtn(number) {
    return this.vendor.handleCallBtn(number);
  }

  addReportEvent() {
    return this.vendor.addReportEvent();
  }

  handleDialOut(precheckParam) {
    return new Promise((resolve, reject) => {
      this._handleDialOut({ ...precheckParam, resolve, reject });
    });
  }

  /**
   * 处理呼出请求
   * @param params
   * @returns {Promise<{autoDialOut: boolean}>}
   */
  _handleDialOut = ({ mode, isIntellectCall, callerNumber, calleeNumber, makeCall, leadDetail, resolve, reject, ...more }) => {
    const params = {
      mode,
      isIntellectCall,
      contactPhone: calleeNumber?.replaceAll?.(' ', ''),
      displayNumber: callerNumber,
      vendor: this.vendor.name,  // 'CALL_CENTER_VENDOR_TCCC',
      uuid: uuid(), // 前端生成的唯一ID
      ...more,
    };

    return this.webApi
      .dialOutCheck()
      .ajaxJson({
        data: params,
      })
      .then((resp) => {
        console.log('第二步, 进入_handleDialOut 调用check函数OutCheck，拿到resp=====', resp);
        const dialOut = (leadId) => {
          const beginCall = () => {
            this.webApi
              .dialOut()
              .dispatchJson(ActionTypes.DIAL_OUT, {
                data: leadId ? _.assign({}, params, { leadId }) : params,
              })
              .then((r2) => {
                console.log('第三分支5，调用dialout接口【触发拨打电话 makecall函数】');
                makeCall(r2.phoneNumber, params, r2, { leadId });
                return r2;
              });
          };
          beginCall();
        };

        // 拨打逻辑
        // 用户点击呼叫链接时直接拨打
        console.log('第三步，用户点击呼叫链接时直接拨打,如果true 就会触发打电话 + 1', _.isEmpty(resp.leadList) && resp.status === 'PHONE_STATUS_WHITE' && resp.autoDialOut);

        if (_.isEmpty(resp.leadList) && resp.status === 'PHONE_STATUS_WHITE' && resp.autoDialOut) {
          return dialOut();
        }
        // 否则就渲染界面
        console.log('第四步, 渲染dialout 界面， 并传入,params, resp, dialOut, leadDetail ', this.dialOutCallback);
        if(resolve) {
          this.setLimitQuickClickCall(false);
          resolve({ params, resp, dialOut, leadDetail });
        }else if (this.dialOutCallback) {
          this.setLimitQuickClickCall(false);
          // 调用了check 后，通过 dialOutCallback 在CallcenterDock 设置setState
          this.dialOutCallback(params, resp, dialOut, leadDetail);
        }
        // 外呼限制必须关联线索权限判断
        const grayPermWithLeads = _.includes(this.loginStatus?.grayPermissions, perms.GRAY_CALL_CENTER_DIAL_OUT_RELATION_LEAD);
        if (grayPermWithLeads && !resp.mobileLead) {
          return resp;
        }
        return resp;
      })
      .catch((error) => {
        if(reject) {
          reject(error);
        }
        message.error(`外呼错误 ${error.message}`);
      });
  }
  hungUp = () => {
    return this.vendor.hungUp();
  }

  updateDisplayNumber = (number) => {
    return this.vendor.updateDisplayNumber(number);
  }
  _handleDialStatusUpdate = (dialStatus, tcccRes) => {
    let conectPhoneNumber = {};
    if(tcccRes.direction === '0') {
      // 呼入
      conectPhoneNumber = {
        contactPhone: tcccRes?.callerPhoneNumber ? `+${tcccRes.callerPhoneNumber.toString().slice(2)}` : '',
        displayNumber: tcccRes?.calleePhoneNumber ?  `+${tcccRes.calleePhoneNumber.toString().slice(2)}` : '',
      };
    }else{
      // 呼出
      conectPhoneNumber = {
        contactPhone: tcccRes?.calleePhoneNumber ? `+${tcccRes.calleePhoneNumber.toString().slice(2)}` : '',
        displayNumber: tcccRes?.callerPhoneNumber ?  `+${tcccRes.callerPhoneNumber.toString().slice(2)}` : '',
      };
    }
    const traceInfo = {
      vendor: 'CALL_CENTER_VENDOR_TCCC',
      isIntellectCall: false,
      ...dialStatus.params,
      ...conectPhoneNumber,
      sessionId: dialStatus.sessionId,
      dialDirection: dialStatus.dialDirection,
      callingStatus: dialStatus.callingStatus,
      actionRecordList: dialStatus.resp?.actionRecordList || [],
    };

    delete traceInfo.leadDetail;
    console.log('3、traceInfo', traceInfo);
    if (traceInfo.leadId) {
      this.webApi
        .traceCalling()
        .ajaxJson({
          data: traceInfo,
        })
        .catch((err) => {
          // 捕获上报异常
          // commonReport.reportError({
          //   message: `TraceInfo: ${traceInfo}; DialStatus: ${dialStatus}; TraceCallingError ${err.message}`,
          //   trace: traceInfo.sessionId,
          // });
        });
    }
  }

  /**
   * @description: 电话呼入
   */
  onDialIn = (callback) => {
    return this.vendor.onDialIn(callback);
  }

  handleDialIn = () => {
    return this.vendor.dialIn();
  }
}

export default TcccCallCenter;
